import React, { FC, useCallback, useRef, useState } from 'react';
import { useParams } from 'react-router';

import Button from 'devextreme-react/button';
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
//devextreme
import { TextBox } from 'devextreme-react/text-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { TextArea } from 'devextreme-react';

import {
  useChangeContractorObjectMutation,
  useCreateContractorObjectMutation,
  useLazyGetContractorObjectDetailQuery,
} from 'bus/contractorObject/services';
import { ContractorObjectItem } from 'bus/contractorObject/types';

type DetailModalRoleProps = {
  id: number | null;
  parentId: number | null;
  refresh: () => void;
  addRoot?: boolean;
  type: 'add' | 'edit';
  contractorIdTaskForm?: number | string; //если открыли форму из страницы создания заявки
};

const initialForm = {
  id: null,
  contractorId: null,
  parentId: null,
  type: 2,
  address: '',
  comment: '',
  residentSalary: null,
  fault: 0,
  nonResidentSalary: null,
  location: 0,
};

const DetailModalObject: FC<DetailModalRoleProps> = (props) => {
  let { id } = useParams<{ id: string }>();

  const [getContractorObjectDetail] = useLazyGetContractorObjectDetailQuery();
  const [createContractorObject, { isLoading: isLoadingCreate }] = useCreateContractorObjectMutation();
  const [changeContractorObject, { isLoading: isLoadingChange }] = useChangeContractorObjectMutation();

  let createCatalogGroupRef = useRef<Form | null>(null);
  let createCatalogGroupValidationRef = useRef<any>(null);

  const [form, setForm] = useState<ContractorObjectItem>({ ...initialForm });
  const [visibleModal, setVisibleModal] = useState<boolean>(false);

  const resetForm = () => {
    setForm({ ...initialForm });
    createCatalogGroupRef.current?.instance.resetValues();
  };

  const getDetail = useCallback(async () => {
    if (props.id) {
      const result = await getContractorObjectDetail({ id: props.id }).unwrap();
      setForm((prev) => ({ ...prev, ...result }));
    }
  }, [getContractorObjectDetail, props.id]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault && e.preventDefault();
    if (createCatalogGroupValidationRef.current?.instance.validate().isValid) {
      if (props.type === 'edit') {
        changeContractorObject({
          ...form,
          contractorId: props.contractorIdTaskForm ? props.contractorIdTaskForm : id,
        });
      } else {
        await createContractorObject({
          ...form,
          id: 0,
          contractorId: props.contractorIdTaskForm ? props.contractorIdTaskForm : id,
          parentId: props.parentId,
        });
      }
    }
    props.refresh();
    resetForm();
    setVisibleModal(false);
  };

  const onShown = () => {
    createCatalogGroupRef.current?.instance.resetValues();
    createCatalogGroupValidationRef.current.instance.reset();
  };

  const onHidden = () => {
    resetForm();
  };

  const isLoading = isLoadingCreate || isLoadingChange;

  return (
    <div>
      <Button
        icon={props.id ? 'edit' : 'add'}
        type="normal"
        stylingMode="text"
        onClick={() => {
          setVisibleModal(true);
          getDetail();
        }}
      />

      {visibleModal && (
        <Popup
          visible={visibleModal}
          onHiding={() => {
            resetForm();
            setTimeout(() => {
              setVisibleModal(false);
            }, 100);
          }}
          dragEnabled={true}
          closeOnOutsideClick={false}
          showTitle={true}
          title="Адрес"
          width={700}
          onShowing={onShown}
          onHidden={onHidden}
          height="auto"
        >
          <div className="modal-block">
            <div className="modal-block__content">
              <form onSubmit={handleSubmit}>
                <ValidationGroup ref={createCatalogGroupValidationRef}>
                  <Form formData={form} ref={createCatalogGroupRef}>
                    <Item colSpan={12} colCount={12} itemType="group">
                      <AppRow>
                        <AppGroup col={12}>
                          <AppFiledBox label="Адрес" labelTop>
                            <TextBox
                              stylingMode="underlined"
                              placeholder="Введите Адрес"
                              mode="text"
                              value={form.address}
                              onChange={(e: any) => {
                                setForm((prev) => ({ ...prev, address: e.event.currentTarget.value }));
                              }}
                            >
                              <Validator>
                                <RequiredRule message="Заполните поле Адрес" />
                              </Validator>
                            </TextBox>
                          </AppFiledBox>

                          <AppFiledBox label="Комментарий" labelTop>
                            <TextArea
                              stylingMode="underlined"
                              placeholder="Введите комментарий"
                              mode="text"
                              value={form.comment}
                              onChange={(e: any) => {
                                setForm((prev) => ({ ...prev, comment: e.event.currentTarget.value }));
                              }}
                            ></TextArea>
                          </AppFiledBox>
                        </AppGroup>
                      </AppRow>
                    </Item>
                  </Form>

                  <ModalFooter
                    useSubmitBehavior={false}
                    handleSubmit={handleSubmit}
                    hideModal={() => {
                      resetForm();
                      setTimeout(() => {
                        setVisibleModal(false);
                      }, 100);
                    }}
                    disabledSubmit={isLoading}
                  />
                </ValidationGroup>
              </form>
            </div>
          </div>
        </Popup>
      )}
    </div>
  );
};

export default DetailModalObject;
